import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const businessCategories = {
  "Diversity-Owned Businesses": [
    "Disability-Owned Business Enterprise (DOBE)",
    "Economically Disadvantaged Women-Owned Small Business (EDWOSB)",
    "LGBTQ (Lesbian, Gay, Bisexual, Transgender, and Queer)",
    "Minority Business Enterprise (MBE)",
    "Small Disadvantaged Business (SDB)",
    "Veteran-Owned Small Business (VOSB)",
    "Women Business Enterprise (WBE)",
  ].sort(),
  "Ethnicity/Nationality-Based Businesses": [
    "African American-Owned Business",
    "Asian-Owned Business",
    "Black-Owned Business",
    "East Asian-Owned Business",
    "Hispanic-Owned Business",
    "Indigenous-Owned Business",
    "Middle Eastern-Owned Business",
    "Native American-Owned Business",
    "Native Hawaiian-Owned Business",
    "Pacific Islander-Owned Business",
    "Pan-African Business",
    "South Asian-Owned Business",
    "Southeast Asian-Owned Business",
  ].sort(),
  "Small & Rural Businesses": [
    "Historically Underutilized Business Zone (HUBZone)",
    "Rural Business",
    "Small Business (SB)",
  ].sort(),
  "Social & Ethical Enterprises": [
    "Benefit Corporation (B Corp)",
    "Community Interest Company (CIC)",
    "Fair Trade Business",
    "Green Business",
    "Public Benefit Corporation (PBC)",
    "Social Enterprise",
    "Sustainable Business",
  ].sort(),
  "Ownership & Organizational Structure": [
    "Cooperative (Co-op)",
    "Employee Stock Ownership Plan (ESOP)",
    "Faith-Based Business",
    "Family-Owned Business",
    "Nonprofit Organization (NPO)",
    "Worker-Owned Cooperative",
  ].sort(),
  "Special Business Ownership Categories": [
    "Immigrant-Owned Business",
    "Refugee-Owned Business",
    "Senior-Owned Business",
    "Youth-Owned Business",
  ].sort(),
};

const CollapsibleSections = ({ onCheckboxChange }) => {
  const [openSections, setOpenSections] = useState({});
  const [selectedBusinesses, setSelectedBusinesses] = useState({});

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleCheckboxChange = (business) => {
    setSelectedBusinesses((prev) => ({
      ...prev,
      [business]: !prev[business],
    }));

    if (onCheckboxChange) {
      onCheckboxChange(business); // Notify the parent component
    }
  };

  return (
    <div className="mb-2">
      {Object.entries(businessCategories).map(([category, businesses]) => (
        <div key={category}>
          <button
            type="button"
            className="flex w-full mb-4 justify-start text-base items-center gap-2 space-y-4"
            onClick={() => toggleSection(category)}
            aria-expanded={openSections[category]}
            aria-controls={category}
          >
            <ChevronRight
              className={`transition-transform duration-300 ${
                openSections[category] ? "rotate-90" : "rotate-0"
              }`}
            />
            {category}
          </button>
          {openSections[category] && (
            <div id={category} className="pl-4 space-y-2 mb-4">
              {businesses.map((business) => (
                <label
                  key={business}
                  className="flex items-center text-[16px] text-gray-600 space-x-2"
                >
                  <input
                    type="checkbox"
                    checked={!!selectedBusinesses[business]}
                    onChange={() => handleCheckboxChange(business)}
                    className="form-checkbox"
                  />
                  <span className="whitespace-nowrap">{business}</span>
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CollapsibleSections;
